class ResourceLock {
  constructor(params) {
    this.resourceId=params.resourceId;
    this.userId=params.userId || PF.userInfo.inituserid;
    this.userName=params.userName || PF.userInfo.initusername;
    this.initunitid = params.initunitid || PF.userInfo.initunitid;
    this.sessionId=params.sessionId;
    this.resTableName = params.resTableName;
    this.docName = params.docName;
    // $(window).unload();
  }

  unlock(callback) {
    let me=this;
    if(me.unLocked)return;
    me.unLocked=true;
    PF.fsrv("resource.lock.srv.unLock",{
      resourceId:this.resourceId,
      userId:this.userId,
      userName:this.userName,
      sessionId:this.sessionId,
      initunitid:this.initunitid
    }).then(o=>{
      if(me.intervalId)clearInterval(me.intervalId);
      callback && callback(o)
    });
  }

  updateLock() {
    let me=this;
    let resourceLockIntervalTime= window.$Env && $Env.resourceLockIntervalTime || 100000;
    me.intervalId = setInterval(() => {
      me.tryLock(null,true);
    }, resourceLockIntervalTime);
  }
  tryLock(callback,noInterval) {
    let me=this;
    PF.fsrv("resource.lock.srv.tryLock",{
      resourceId:this.resourceId,
      userId:this.userId,
      userName:this.userName,
      sessionId:this.sessionId,
      resTableName:this.resTableName,
      docName:this.docName
    },r=>{
      r=r && r.result;
      if (!noInterval && r && r.success) {
        me.updateLock();
      }
      if (callback) {
        callback(r);
      }
    });
  }

  destroy() {
    if(this.intervalId)clearInterval(this.intervalId);
  }
}
window.ResourceLock=ResourceLock;

export default ResourceLock;



// WEBPACK FOOTER //
// ./src/common/utils/resourceLock.js